import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button, ButtonSizes } from 'ui-components/components/button';
import { Dropdown } from 'ui-components/components/INTERNAL/dropdown';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { Text, TextType } from 'ui-components/components/text';
import { FlexRow } from 'ui-components/components/flex';

import ShipTo from '../../orders/ship-to';
import { messages } from '../messages';
import styles from './address-dropdown.module.less';

const shouldAllowDropdownToClose = (e) => {
  if (!e.target.classList || !e.target.classList.length) {
    return false;
  }
  return [...new Set(e.target.classList)].some((cssClass) => cssClass.indexOf('dropdown-label') !== -1);
};

export const AddressDropdown = ({ salesOrderId, fulfillmentPlanId }) => {
  return (
    <div className={styles['view-address-link']}>
      <Dropdown closeWhenChildrenClicked={false} containerAllowedMeToClose={(e) => shouldAllowDropdownToClose(e)}>
        <Button buttonSize={ButtonSizes.large} theme={THEME_CONSTANTS.link}>
          <FormattedMessage {...messages.addressDropdownToggler} />
        </Button>
        <div className={styles['view-address-dropdown-container']}>
          <div className={styles['tooltip-arrow']} />
          <FlexRow className={styles['dropdown-label']}>
            <Text textType={TextType.H4} value={messages.addressDropdownMenuTitle} />
            <FontAwesomeIcon className={styles['x-icon']} icon={faXmark} />
          </FlexRow>
          <ShipTo
            className={styles['ship-to-address']}
            hideAddress3
            salesOrderId={salesOrderId}
            selectedFulfillmentPlanId={fulfillmentPlanId}
          />
        </div>
      </Dropdown>
    </div>
  );
};

AddressDropdown.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
};
